import React, { Component } from 'react';
import selecionarAdesaoPonto from '../../actions/adesao-pontos/selecionarAdesaoPonto';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

const StatusBadge = ({ active }) => (
    <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 700,
        background: active ? 'rgba(40,167,69,0.12)' : 'rgba(108,117,125,0.10)',
        color: active ? '#1e7e34' : '#6c757d',
    }}>
        <i className="material-icons" style={{ fontSize: 11 }}>{active ? 'check_circle' : 'cancel'}</i>
        {active ? 'Ativo' : 'Inativo'}
    </span>
);

export class AdesaoPonto extends Component {

    render() {
        const { adesaoPonto } = this.props;

        return (
            <tr>
                <td>
                    <span style={{ color: '#aaa', fontSize: 11, marginRight: 6 }}>
                        #{adesaoPonto.empresa.id}
                    </span>
                    <span style={{ fontWeight: 600 }}>{adesaoPonto.empresa.nome}</span>
                </td>
                <td>{adesaoPonto.peso}</td>
                <td>{adesaoPonto.quantidadePonto}</td>
                <td><StatusBadge active={adesaoPonto.habilitadoGeracaoPontos} /></td>
                <td><StatusBadge active={adesaoPonto.habilitadoConsumoPontos} /></td>
                <td>
                    <div className="vx-row-actions">
                        <button
                            type="button"
                            className="vx-row-btn"
                            title="Editar configuração"
                            onClick={() => {
                                this.props.selecionarAdesaoPonto(adesaoPonto);
                                this.props.history.push('/painel-cadastro-configuracao-ponto');
                            }}>
                            <i className="material-icons">edit</i>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }
}

export default withRouter(connect(null, {
    selecionarAdesaoPonto,
})(reduxForm({
    form: 'formularioPainelAdesaoPontos',
})(AdesaoPonto)));
